<template>
  <div class="widget white_box">
    <div class="widget_header">
      <div class="location_tag">
        <h3 class="heading">
          Scheduled Posts
        </h3>
        <div class="sub_heading">
          Location: {{ selectedLocation }}
        </div>
      </div>
      <a
        v-if="!editing && !preview"
        class="btn primary_btn btn_sm"
        href="/local/business-profile/posts"
      >
        See More
      </a>
      <div
        v-if="editing && !preview"
        class="edit_buttons"
      >
        <button
          v-if="widget.editable"
          class="btn btn_sm btn-info"
          @click="$parent.edit(widget)"
        >
          Options
        </button>
        <button
          class="btn btn_sm btn-danger"
          @click="$parent.remove(widget)"
        >
          Delete
        </button>
      </div>
    </div>
    <div
      v-if="!loading && posts.length > 0"
      class="posts"
    >
      <div
        v-for="(post, index) in posts"
        :key="index"
        class="post_card"
      >
        <div class="img">
          <div class="post_card_top">
            <div class="time">
              <i class="icon clock_item" />
              <span class="p_x_small font_md">{{ niceDate(post.date_scheduled) }}</span>
            </div>
          </div>
          <img
            :src="post.media_url ?? '/assets/images/gmb/no-image-placeholder.png'"
            alt=""
          >
          <span
            v-if="expired(post.date_created)"
            class="img_label"
          >Expired</span>
        </div>
        <div class="desc">
          <div class="p_small">
            {{ post.summary }}
          </div>
          <button class="btn primary_btn btn_sm">
            {{ post.cta_text }}
          </button>
        </div>
      </div>
    </div>

    <div
      v-else
      class="loading_widget_data"
    >
      <div
        v-if="loading && !error"
        class="loading_widget_data"
      >
        <i class="fa fa-btn fa-spinner fa-spin" /> Loading Data
      </div>

      <div
        v-else-if="error"
        class="widget_error"
        v-html="error"
      />

      <div v-else>
        No scheduled posts
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import {mapState} from 'vuex';
import axios from 'axios';
import _ from 'lodash';

export default {
  props: {
    widget: {
      type: Object,
      required: true,
    },
    editing: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      loading: true,
      posts: [],
      error: null,
    }
  },
  computed: {
    ...mapState('dashboard', ['uuid', 'preview', 'gmbLocations']),
    selectedLocation() {
      return this.gmbLocations[this.widget.location_id];
    }
  },
  watch: {
    'widget.location_id': {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) this.fetchData();
      },
      deep: true
    }
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      axios.post('/ajax/dashboard/get-widget-data', {
        type: 'scheduledPosts',
        location_id: this.widget.location_id,
        uuid: this.uuid
      }).then(response => {
        this.posts = response.data;
        this.loading = false;
      }).catch(error => {
        this.error = error.response.data;
        this.loading = false;
      });
    },
    niceDate(date) {
      return moment(date).format('Do MMMM YYYY');
    },
    expired(dateCreated) {
      return moment(dateCreated).isBefore(moment().subtract(7, 'days'));
    },
  },
}
</script>

<style scoped>
.posts {
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: 85%;
}

.post_card {
  border-radius: 0.75rem;
  border: 1px solid #E8E5E2;
  overflow: hidden;
  width: 32%;
  height: 100%;
}

.post_card .img {
  position: relative;
  width: 100%;
  height: 50%;
  overflow: hidden;
}

.post_card .img img {
  width: 100%;
}

.post_card .desc {
  background-color: white;
  padding: 1rem 1.5rem 2rem;
}

.post_card .post_card_top {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  top: 0;
  left: 0;
  padding: 0.5rem 0.75rem;
}

.post_card .post_card_top .time {
  background: rgb(0 0 0 / 50%);
  padding: 0.25rem;
  border-radius: 10px;
}

.post_card .post_card_top .time span {
  color: white;
}

.post_card .post_card_top .time .clock_item {
  width: 1rem;
  height: 1rem;
  background-image: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='7.99992' cy='7.99992' r='6.41667' stroke='white' stroke-width='1.21041'/%3E%3Cpath d='M8 5.0835V8.5835L9.45833 10.0418' stroke='white' stroke-width='1.21041' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
}

.post_card .img .img_label {
  position: absolute;
  bottom: 9px;
  right: 8px;
  padding: 0.25rem 0.5rem;
  background-color: #FFEEEA;
  color: #F34F4F;
  border-radius: 6px;
  font-size: 0.75rem;
  line-height: 15px;
}

.post_card .desc {
  background-color: white;
  padding: 1rem 1.5rem 1rem;
}

.post_card .desc .p_small {
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-bottom: .5rem;
}

.desc button {
  width: 100%;
}
</style>
